
import { set, lensPath, equals } from 'ramda';
import * as types from './types';
import { JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { LabelSettingsService } from '../../services/label-settings.service';
import { MODIFICATION_URL, SETTINGS_URL } from '../../../../services/common-urls';
import { random, generateNextId, isNegative } from '../../../../utility/fp';
import { LABEL_URL } from '../../../accounting/services/costs.service';
import { taskService } from '../../../tasks/services/tasks.service';

// Action Object for LabelSettings. Import the types from label/types.js and Invoke Actions from the Vuex Host Components.

export const labelSettingsActions = {
  async [types.LabelSettingsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      label_setting_loading: true,
    });
    const labelSettingsData = await HttpClient.mergeRequests([
      // LabelSettingsService.findLabelSettings(),
      LabelSettingsService.findLabelSettings2(),
      // LabelSettingsService.findRoyaltyDealTypes(),
      // LabelSettingsService.findAdvanceTypes(),

      // LabelSettingsService.findAdditionalInfo(),
      // LabelSettingsService.findLabelStatuses(),
      // LabelSettingsService.findShippingTypes(),
      // LabelSettingsService.findLicenseSettings(),
      // LabelSettingsService.findInitLicensingSettings(),
      // LabelSettingsService.findMechanical(),
      // LabelSettingsService.findSharingData()
    ]);
    dispatch(types.MarketingTypes.FETCH.ALL);
    dispatch(types.LicenceStatus.FETCH.ALL);
    dispatch(types.LabelStatus.FETCH.ALL);
    dispatch(types.APIConfig.FETCH.ALL);
    dispatch(types.ShippingType.FETCH.ALL);
    dispatch(types.AdvanceType.FETCH.ALL);
    // dispatch(types.DealTypes.FETCH.ALL);
    dispatch(types.MechanicalRate.FETCH.ALL);

    const external_table = [ 'licence' , 'release' ,'product' , 'contract' ]

    for(let i = 0;i<external_table.length;i++)
    {
      dispatch(types.TaskTypes.FETCH.ALL,{external_table:external_table[i]});
    }

    commit(types.LabelSettingsData.SET.ALL, {
      label_setting_loading: false,
      ...labelSettingsData
    });
  },
  async [types.TaskTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { external_table } =payload
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      [`${external_table}_task_loading`]: true,
    });
    const licenseSettingsData = await taskService.taskTemplateGroup(external_table)
    console.log(licenseSettingsData,"loading")
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      ...licenseSettingsData.data,
      [`${external_table}_task_loading`]: false,
    });
    console.log(getters.labelSettingsData,"loading getters")
  },
  async [types.AdvanceType.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      advance_types_loading: true,
    });
    const licenseSettingsData = await LabelSettingsService.findAdvanceTypes().then(res => res.data);
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      ...licenseSettingsData,
      advance_types_loading: false,
    });
  },
  async [types.DealTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      deal_types_loading: true,
    });
    const licenseSettingsData = await LabelSettingsService.findRoyaltyDealTypes().then(res => res.data);
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      ...licenseSettingsData,
      deal_types_loading: false,
    });
  },
  async [types.MarketingTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      marketing_types_loading: true,
    });
    const licenseSettingsData = await LabelSettingsService.findInitLicensingSettings().then(res => res.data);
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      ...licenseSettingsData,
      marketing_types_loading: false,
    });
  },

  async [types.APIConfig.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      translator_api_configs_loading: true,
    });
    const translatorAPIConfigData = await LabelSettingsService.findAdditionalInfo().then(res => res.data);
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      ...translatorAPIConfigData,
      translator_api_configs_loading: false,
    });
  },

  async [types.Formats.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      format_name,
      album_single_merch,
      physical_digital_merch,
      two_sides_flag,
      default_weight,
      vat_type,
      channel,
      min_margin,
      mechanical_min_ppu,
      internal_flag,
    } = payload;


    // Temporarily Push the new Format data

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      formats: [
        ...getters.labelSettingsData.formats,
        {
          format_name,
          album_single_merch,
          physical_digital_merch,
          two_sides_flag,
          default_weight,
          vat_type,
          channel,
          min_margin,
          mechanical_min_ppu,
          internal_flag,
        }
      ]
    });

    //Making the HTTP Call to insert the data into the database
    const newFormat = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_format',
      format_name,
      album_single_merch,
      physical_digital_merch: channel,
      two_sides_flag,
      default_weight,
      vat_type,
      min_margin,
      mechanical_min_ppu,
      internal_flag,
    });

    // Disptacting the Fetch all formats actin
    dispatch(types.Formats.FETCH.ALL);
  },
  async [types.Formats.FETCH.ALL]({ commit, getters }) {
    const allFormats = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_formats',
      output: JSON_STRING
    });

    // Committing the response to the store
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      formats: allFormats.data.formats
    });
  },

  async [types.Formats.UPDATE.SINGLE]({ commit, getters }, payload) {
    console.log(payload);

    const { name, value, item } = payload;

    const { format_id } = item;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      formats: getters.labelSettingsData.formats.
        map(f => {
          if (f.format_id == format_id) {
            return {
              ...f,
              [name]: value,
            };
          } else {
            return f;
          }
        })
    });

    const updatedFormat = await HttpClient.post(MODIFICATION_URL, {
      kVal: format_id,
      name,
      value,
      table: 'l_formats',
      modify_type: '',
      json_op: '',
      json_key: ''
    });
  },
  async [types.Formats.SET.SINGLE]({ commit, getters }, payload) {
    const {
      format_id,
      format_name,
      album_single_merch,
      channel,
      two_sides_flag,
      default_weight,
      vat_type,
      min_margin,
      mechanical_min_ppu,
      internal_flag,
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      formats: getters.labelSettingsData.formats.
        map(format => {
          if (format.format_id == format_id) {
            return {
              ...format,
              ...payload
            };
          } else {
            return format;
          }
        })
    });

    const updatedFormat = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'l_formats',
      kVal: format_id,
      format_name,
      album_single_merch,
      channel,
      two_sides_flag,
      default_weight,
      vat_type,
      min_margin,
      mechanical_min_ppu,
      internal_flag,
    });
  },
  async [types.Formats.DELETE.SINGLE]({ commit, getters }, payload) {
    const { format_id } = payload;

    // Removing the Format from the store Before the database
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      formats: getters.labelSettingsData.formats.
        filter(format => format.format_id != format_id)
    });

    const deletedFormat = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_format',
      format_id
    });
  },


  // Product Type Store Actions

  async [types.ProductTypes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      product_type_name,
      valuelist,
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      product_types: [
        ...getters.labelSettingsData.product_types,
        {
          product_type_name,
          valuelist
        }
      ]
    });

    const newProductType = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_product_type',
      product_type_name,
      valuelist,
    });

    dispatch(types.ProductTypes.FETCH.ALL);
  },
  async [types.ProductTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const allProductTypes = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_product_types',
      output: JSON_STRING
    });

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      product_types: allProductTypes.data.product_types
    });
  },
  async [types.ProductTypes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      product_type_id,
      product_type_name,
      valuelist
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      product_types: getters.labelSettingsData.product_types.
        map(pt => {
          if (pt.product_type_id == product_type_id) {
            return {
              ...pt,
              product_type_name,
              valuelist,
            };
          } else {
            return pt;
          }
        })
    });

    const updatedProductType = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'l_product_types',
      kVal: product_type_id,
      product_type_name,
      valuelist,
    });
  },
  async [types.ProductTypes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { product_type_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      product_types: getters.labelSettingsData.product_types.
        filter(p => p.product_type_id != product_type_id)
    });

    const removedProductType = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_product_type',
      product_type_id,
    });
  },

  // Price List Actions
  async [types.PriceLists.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      price_list_name,
      currency_id,
      price_code_ids,
      prices,
      paybacks
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_lists: [
        ...getters.labelSettingsData.price_lists,
        {
          price_list_name,
          currency_id,
          price_code_ids,
          prices,
          paybacks
        },
      ]
    });

    const newPriceList = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_price_list',
      price_list_name,
      currency_id,
      price_code_ids,
      prices,
      paybacks
    });

    dispatch(types.PriceLists.FETCH.ALL);
  },
  async [types.PriceLists.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const all_price_list = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_price_lists',
      output: JSON_STRING,
    });

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_lists: all_price_list.data.price_lists,
    });
  },
  async [types.PriceLists.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      price_list_id,
      price_list_name,
      currency_id,
      price_code_ids,
      prices,
      paybacks
    } = payload;

    const updatePriceList = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'edit_price_list',
      price_list_id,
      price_list_name,
      currency_id,
      price_code_ids, //: 21,11,15,14
      prices, //: 12.00,23.00,23.00,19
      paybacks,
    });
    dispatch(types.PriceLists.FETCH.ALL);
  },
  async [types.PriceLists.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { price_list_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_lists: getters.labelSettingsData.price_lists.
        filter(e => e.price_list_id != price_list_id)
    });

    const removedPriceList = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_price_list',
      price_list_id
    })
  },

  //Media Types Actions

  async [types.MediaTypes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      media_name,
      mechanical_name,
      mechanical_no,
      mechanical_reserve,
    } = payload;

    // Temporarily adding the Media Type

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      media_types: [
        ...getters.labelSettingsData.media_types,
        {
          media_name,
          mechanical_name,
          mechanical_no,
          mechanical_reserve,
        }
      ]
    });

    const newMediaType = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_media',
      media_name,
      mechanical_name,
      mechanical_no,
      mechanical_reserve,
    });

    dispatch(types.MediaTypes.FETCH.ALL);
  },
  async [types.MediaTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const allMedia = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_media',
      output: JSON_STRING,
    });

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      media_types: allMedia.data.media_types,
    });
  },
  async [types.MediaTypes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      media_id,
      media_name,
      mechanical_name,
      mechanical_no,
      mechanical_reserve,
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      media_types: getters.labelSettingsData.media_types.
        map(l => {
          if (l.media_id == media_id) {
            return {
              ...l,
              media_name,
              mechanical_name,
              mechanical_no,
              mechanical_reserve,
            };
          } else {
            return l;
          }
        })
    });

    const updatedMediaType = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'l_media',
      kVal: media_id,
      media_name,
      mechanical_name,
      mechanical_no,
      mechanical_reserve,
    });

    dispatch(types.MediaTypes.FETCH.ALL);
  },
  async [types.MediaTypes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { media_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      media_types: getters.labelSettingsData.media_types.
        filter(m => m.media_id != media_id)
    });

    const deleteMediaType = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_media',
      media_id
    });
  },

  // Price Code Actions
  async [types.PriceCodes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      price_code_name,
      price_code_description,
      price_code_groups,
      price_list_ids,
      prices,
      paybacks
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_codes: [
        ...getters.labelSettingsData.price_codes,
        {
          price_code_name,
          price_code_description,
        },
      ]
    })

    const newPricCode = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_price_code',
      price_code_name,
      price_code_description,
      price_code_groups,
      price_list_ids,
      prices,
      paybacks
    });

    dispatch(types.PriceCodes.FETCH.ALL);
  },
  async [types.PriceCodes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const allPriceCodes = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_price_codes',
      output: JSON_STRING,
    });
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_codes: allPriceCodes.data.price_codes
    });
  },
  async [types.PriceCodes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      price_code_id,
      price_code_name,
      price_code_description,
      price_code_groups,
      price_list_ids,
      prices,
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_codes: getters.labelSettingsData.price_codes.
        map(p => {
          if (p.price_code_id == price_code_id) {
            return {
              ...p,
              price_code_name,
              price_code_description,
            };
          } else {
            return p;
          }
        })
    })

    const updatedPriceCode = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'edit_price_code',
      price_code_id,
      price_code_name,
      price_code_description,
      price_code_groups,
      price_list_ids, //: 1,2,18,27,29,31
      prices, //: 4.75,4.25,2.00,12.00,12.00,41.00
    });
    dispatch(types.PriceCodes.FETCH.ALL);
  },
  async [types.PriceCodes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { price_code_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      price_codes: getters.labelSettingsData.price_codes.
        filter(p => p.price_code_id != price_code_id)
    });

    const removedPriceCode = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_price_code',
      price_code_id,
    });
  },



  // API Config Actions
  async [types.APIConfig.SET.ALL]({ commit, getters, dispatch }, payload) {
    const translator_api_configs = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      translator_api_configs
    });

    const updatedApiConfig = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'save_translator_api_configs',
      translator_api_configs: JSON.stringify(translator_api_configs)
    });
  },
  async [types.APIConfig.UPDATE.ALL]({ commit, getters, dispatch }, payload) {
    const { name, value, form_name, index } = payload;

    const translator_api_configs = set(lensPath([form_name, index, name]), value, getters?.labelSettingsData?.translator_api_configs);

    dispatch(types.APIConfig.SET.ALL, translator_api_configs);
  },
  // async [types.APIConfig.SET.MULTIPLE]({ commit, getters, dispatch }, payload) {
  //   const { name, value, form_name, index } = payload;

  //   const translator_api_configs = set(lensPath([form_name, index, name]), value, getters?.labelSettingsData?.translator_api_configs);

  //   //Setting The State Value -- because previous set in the SET.ALL action does not work for a invalidated Form Submission
  //   commit(types.LabelSettingsData.SET.ALL, {
  //     ...getters.labelSettingsData,
  //     translator_api_configs
  //   });
  // },
  async [types.APIConfig.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { source, data } = payload;
    console.log({ "getters?.labelSettingsData?.translator_api_configs": getters?.labelSettingsData?.translator_api_configs });
    console.log({ "payload": payload });
    const translator_api_configs = {
      ...getters?.labelSettingsData?.translator_api_configs,
      [source]: [
        ...(getters?.labelSettingsData?.translator_api_configs?.[source] || []),
        data
      ]
    };

    console.log({ "translator_api_configs": translator_api_configs });

    dispatch(types.APIConfig.SET.ALL, translator_api_configs);
  },
  async [types.APIConfig.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { form_name, item } = payload;

    const translator_api_configs = {
      ...getters?.labelSettingsData?.translator_api_configs,
      [form_name]: getters?.labelSettingsData?.translator_api_configs[form_name].filter(f => {
        return !equals(item, f);
      })
    };

    console.log(translator_api_configs);

    dispatch(types.APIConfig.SET.ALL, translator_api_configs);
  },

  // Licence Status Actions
  async [types.LicenceStatus.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { licence_status_text } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      licence_statuses: [
        ...getters.labelSettingsData.licence_statuses,
        {
          licence_status_id: random(100000, 10000),
          licence_status_text
        }
      ]
    });

    const insertedLicence = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'add_licence_status',
      licence_status_text
    });

    dispatch(types.LicenceStatus.FETCH.ALL);
  },
  async [types.LicenceStatus.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      licence_statuses_loading: true,
    });
    const all_licence = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'load_all_licence_status',
      output: JSON_STRING
    });
    console.log(all_licence);

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      licence_statuses: all_licence.data.licence_statuses,
      licence_statuses_loading: false,
    });
  },
  async [types.LicenceStatus.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { licence_status_text, licence_status_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      licence_statuses: getters.labelSettingsData.licence_statuses.map(l => {
        if (l.licence_status_id == licence_status_id) {
          return {
            ...l,
            licence_status_text
          };
        } else {
          return l;
        }
      })
    });

    const insertedLicence = await HttpClient.post(MODIFICATION_URL, {
      modify_type: 'record',
      table: 'l_licence_statuses',
      kVal: licence_status_id,
      licence_status_text,
    });

    dispatch(types.LicenceStatus.FETCH.ALL);
  },
  async [types.LicenceStatus.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { licence_status_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      licence_statuses: getters.labelSettingsData.licence_statuses.filter(l => {
        return l.licence_status_id != licence_status_id
      })
    });

    const removedLicenceStatus = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'remove_licence_statuse',
      licence_status_id
    });
  },


  //LabelStatus Functions
  async [types.LabelStatus.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log({ "payload": payload });

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      label_statuses: [
        ...getters.labelSettingsData.label_statuses,
        payload
      ],
      label_statuses_loading: true,
    });

    await LabelSettingsService.createUpdateLabelStatus(payload);

    dispatch(types.LabelStatus.FETCH.ALL);
  },

  async [types.LabelStatus.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const label_statusesResponse = await LabelSettingsService.findLabelStatuses();

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      label_statuses: label_statusesResponse.data.label_statuses,
      label_statuses_loading: false,
    });
  },
  async [types.LabelStatus.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      label_statuses: getters.labelSettingsData.label_statuses.map(labelStatus => {
        if (labelStatus.label_status_id == payload.label_status_id) {
          return {
            ...labelStatus,
            ...payload
          };
        } else {
          return labelStatus;
        }
      }),
      label_statuses_loading: true,
    });
    await LabelSettingsService.createUpdateLabelStatus(payload);
    dispatch(types.LabelStatus.FETCH.ALL);
  },
  async [types.LabelStatus.DELETE.SINGLE]({ commit, getters, dispatch }, label_status_id) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      label_statuses: getters.labelSettingsData.label_statuses.filter(labelStatus => {
        return labelStatus.label_status_id != label_status_id;
      }),
      label_statuses_loading: true,
    });
    await LabelSettingsService.deleteLabelStatus(label_status_id);
    dispatch(types.LabelStatus.FETCH.ALL);
  },

  // Shipping Type Functions

  async [types.ShippingType.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    console.log({ "payload": payload });
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      shipping_types: [
        ...getters.labelSettingsData.shipping_types,
        payload
      ],
      shipping_types_loading: true,
    });

    await LabelSettingsService.createUpdateShippingType(payload);

    dispatch(types.ShippingType.FETCH.ALL);
  },
  async [types.ShippingType.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      shipping_types: getters.labelSettingsData.shipping_types,
      shipping_types_loading: true,
    });
    const shipping_typesResponse = await LabelSettingsService.findShippingTypes();
    console.log({ shipping_typesResponse });
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      shipping_types: shipping_typesResponse.data.shipping_types,
      shipping_types_loading: false,
    });
  },
  async [types.ShippingType.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      shipping_types: getters.labelSettingsData.shipping_types.map(shippingType => {
        if (shippingType.shipping_type_id == payload.shipping_type_id) {
          return {
            ...shippingType,
            ...payload
          };
        } else {
          return shippingType;
        }
      }),
      shipping_types_loading: true,
    });
    await LabelSettingsService.createUpdateShippingType(payload);
    dispatch(types.ShippingType.FETCH.ALL);
  },
  async [types.ShippingType.DELETE.SINGLE]({ commit, getters, dispatch }, shipping_type_id) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      shipping_types: getters.labelSettingsData.shipping_types.filter(shippingType => {
        return shippingType.shipping_type_id != shipping_type_id;
      }),
      shipping_types_loading: true,
    });
    await LabelSettingsService.deleteShippingType(shipping_type_id);
    dispatch(types.ShippingType.FETCH.ALL);
  },


  //Marketing Type Acitons
  async [types.MarketingTypes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {



      ...getters.labelSettingsData,
      marketing_types: [
        {
          marketing_type_id: generateNextId(getters.labelSettingsData.marketing_types.map(e => +e.marketing_type_id)),
          marketing_type_name: '',
        },
        ...getters.labelSettingsData.marketing_types,
      ]
    });
  },
  async [types.MarketingTypes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { name, value, item } = payload;
    const { marketing_type_id } = item;

    if (isNegative(item.marketing_type_id)) {

      const insertedMarketingType = await HttpClient.post(SETTINGS_URL, {
        section: 'labelsettings',
        action: 'add_marketing_type',
        marketing_type_name: value,
      });
      const new_marketing_type_id = insertedMarketingType.data.marketing_type_id;

      commit(types.LabelSettingsData.SET.ALL, {
        ...getters.labelSettingsData,
        marketing_types: getters.labelSettingsData.marketing_types.map(m => {
          if (m.marketing_type_id == marketing_type_id) {
            return {
              ...m,
              marketing_type_id: new_marketing_type_id,
              marketing_type_name: value,
            };
          } else {
            return m;
          }
        })
      });
    } else {
      commit(types.LabelSettingsData.SET.ALL, {
        ...getters.labelSettingsData,
        marketing_types: getters.labelSettingsData.marketing_types.map(m => {
          if (m.marketing_type_id == marketing_type_id) {
            return {
              ...m,
              marketing_type_name: value,
            };
          } else {
            return m;
          }
        })
      });
      const updatedMarketingType = await HttpClient.post(MODIFICATION_URL, {
        kVal: marketing_type_id,
        name: 'marketing_type_name',
        value,
        table: 'p_marketing_types',
        modified: '{last_modified}',
        modify_type: '',
        json_op: '',
      });
    }
  },
  async [types.MarketingTypes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { item } = payload;
    const { marketing_type_id } = item;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      marketing_types: getters.labelSettingsData.marketing_types.filter(m => {
        return m.marketing_type_id != marketing_type_id
      })
    });

    if (!isNegative(item.marketing_type_id)) {
      const removedMarketingType = await HttpClient.post(SETTINGS_URL, {
        section: 'labelsettings',
        action: 'delete_marketing_type',
        marketing_type_id
      });
    }
  },


  // Deal Types Actions
  async [types.DealTypes.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { deal_type_name, deal_type_code } = payload;
    const deal_type_id = generateNextId(getters.labelSettingsData.deal_types.map(e => +e.deal_type_id));

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      deal_types: [
        ...getters.labelSettingsData.deal_types,
        {
          deal_type_name,
          deal_type_code,
          deal_type_id
        }
      ]
    });
    const deal_types = await HttpClient.post(LABEL_URL, {
      section: 'royalty',
      action: 'new_deal_type',
      deal_type_name,
      deal_type_code
    }).then(res => res.data.deal_types);

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      deal_types
    });
  },
  async [types.DealTypes.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      deal_type_id,
      deal_type_name,
      deal_type_code
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      deal_types: getters.labelSettingsData.deal_types.map(e => {
        if (e.deal_type_id == deal_type_id) {
          return {
            ...e,
            deal_type_name,
            deal_type_code,
          };
        } else {
          return e;
        }
      })
    });

    const updatedDealType = await HttpClient.post(LABEL_URL, {
      section: 'royalty',
      action: 'edit_deal_type',
      deal_type_name,
      deal_type_code,
      deal_type_id
    });
  },
  async [types.DealTypes.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const {
      deal_type_id
    } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      deal_types: getters.labelSettingsData.deal_types.filter(e => {
        return e.deal_type_id != deal_type_id;
      })
    });

    const updatedDealType = await HttpClient.post(LABEL_URL, {
      section: 'royalty',
      action: 'delete_deal_type',
      deal_type_id
    });
  },

  //Advance Type Actions
  async [types.AdvanceType.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    const { advance_type_name } = payload;

    const new_id = generateNextId(getters.labelSettingsData.advance_types.map(e => +e.advance_type_id));

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      advance_types: [
        ...getters.labelSettingsData.advance_types,
        {
          advance_type_name,
          advance_type_id: new_id
        }
      ]
    });

    const advance_type_id = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'open_add_edit_advance_type',
      advance_type_name
    }).then(res => res.data.advance_type_id);

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      advance_types: getters.labelSettingsData.advance_types.map(e => {
        if (e.advance_type_id == new_id) {
          return {
            ...e,
            advance_type_id
          };
        } else {
          return e;
        }
      })
    });
  },
  async [types.AdvanceType.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { advance_type_id, advance_type_name } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      advance_types: getters.labelSettingsData.advance_types.map(e => {
        if (e.advance_type_id == advance_type_id) {
          return {
            ...e,
            advance_type_name,
            advance_type_id
          };
        } else {
          return e;
        }
      })
    });

    const updated_advance_type = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'open_add_edit_advance_type',
      advance_type_name,
      advance_type_id,
    });
  },
  async [types.AdvanceType.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { advance_type_id } = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      advance_types: getters.labelSettingsData.advance_types.filter(e => {
        return e.advance_type_id != advance_type_id;
      })
    });

    const deleted_advance_type = await HttpClient.post(SETTINGS_URL, {
      section: 'labelsettings',
      action: 'delete_advance_type',
      advance_type_id
    });
  },


  // Mechanical Rate Actions
  async [types.MechanicalRate.INSERT.SINGLE]({ commit, getters, dispatch }, payload) {
    // For now it seems that the Mechanical Rate Add API does not add a new Row - This is probably some sor of Sync API rather than a Pure ADD API. 
    // Need to resolve this later. 

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates_loading: true
    });
    const mechanicalRateList = await LabelSettingsService.createMechanical();
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates: mechanicalRateList.data.rates,
      rates_loading: false
    });
  },
  async [types.MechanicalRate.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates_loading: true
    });
    const mechanicalRateList = await LabelSettingsService.findMechanical();
    console.log("mechanicalRateList.data.rates", mechanicalRateList.data.rates);    
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates: mechanicalRateList.data.rates,
      rates_loading: false
    });
  },
  async [types.MechanicalRate.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { item: mechanical_rate, name, value } = payload;
    const { mechanical_rate_id } = mechanical_rate;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates: getters.labelSettingsData.rates.map(e => {
        if (e.mechanical_rate_id == mechanical_rate_id) {
          return {
            ...e,
            [name]: value
          };
        } else {
          return e;
        }
      }),
      rates_loading: true,
    });

    // const updatedRate = await HttpClient.post(SETTINGS_URL, {
    //   section: 'labelsettings',
    //   action: 'open_add_edit_mechanical_rate',
    //   rate_name,
    //   rate_value,
    //   rate_id
    // });

    const updatedRate = await HttpClient.modifyJSON(
      undefined,
      mechanical_rate_id,
      name,
      value,
      'l_mechanical_rates',
    );
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates_loading: false,
    });

  },
  async [types.MechanicalRate.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {
    const mechanical_rate_id = payload;

    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates: getters.labelSettingsData.rates.filter(e => {
        return e.mechanical_rate_id != mechanical_rate_id;
      }),
      rates_loading: true,
    });
    const deletedRate = await LabelSettingsService.removeMechanical(mechanical_rate_id);
    commit(types.LabelSettingsData.SET.ALL, {
      ...getters.labelSettingsData,
      rates_loading: false,
    });
  },
}
